const resolveBoolean = (value, defaultValue = false) => {
  if (value === null || value === undefined) return defaultValue;
  if (value === true || value === 'true' || value === 'TRUE') return true;
  return false;
};

const resolveInteger = (value, defaultValue = 0) => {
  return /^\d+$/.test(value) ? parseInt(value, 10) : defaultValue;
};

const resolveJSON = (value, defaultValue = {}) => {
  return (value && JSON.parse(value)) || defaultValue;
};

const TIME_BEFORE_CLOSE_APP_SECOND = 10;
const HOME_URL = 'capacitor://localhost';
// REDIRECT_URL will be deprecated soon, please use APP_URL and urljoin instead
const REDIRECT_URL = process.env.REDIRECT_URL || '/#/./login-loading';
const LOGIN_LOADING_TIMEOUT = 10000;
const IS_STORAGE_MODE = resolveBoolean(process.env.IS_STORAGE_MODE, false);
const IS_SHOW_VIDEO_RESOLUTION = resolveBoolean(process.env.IS_SHOW_VIDEO_RESOLUTION, true);
const IS_OVERRIDE_NATIVE_HLS = resolveBoolean(process.env.IS_OVERRIDE_NATIVE_HLS, false);
const IS_OVERRIDE_LOADEDMETADATA = resolveBoolean(process.env.IS_OVERRIDE_LOADEDMETADATA, false);
const APP_ORIGIN =
  process.env.ORIGIN || (typeof window !== 'undefined' ? window.location.origin : undefined);
const APP_ROUTE_BASENAME = process.env.APP_ROUTE_BASENAME;
const IS_SHOW_MY_COURSE_NAVIGATION_ARROW = resolveBoolean(
  process.env.IS_SHOW_MY_COURSE_NAVIGATION_ARROW,
  false
);
const APP_URL = process.env.APP_URL;
const APP_SECURE_LOGIN_CALLBACK_URL = process.env.APP_SECURE_LOGIN_CALLBACK_URL;

/**
 * Config below only use in Anywhere.
 */
const GAMIFICATION_JWT_SECRET = process.env.GAMIFICATION_JWT_SECRET;

module.exports = {
  TIME_BEFORE_CLOSE_APP_SECOND,
  HOME_URL,
  REDIRECT_URL,
  LOGIN_LOADING_TIMEOUT,
  IS_STORAGE_MODE,
  IS_SHOW_VIDEO_RESOLUTION,
  IS_OVERRIDE_NATIVE_HLS,
  IS_OVERRIDE_LOADEDMETADATA,
  APP_ORIGIN,
  APP_ROUTE_BASENAME,
  IS_SHOW_MY_COURSE_NAVIGATION_ARROW,
  APP_URL,
  APP_SECURE_LOGIN_CALLBACK_URL,
  GAMIFICATION_JWT_SECRET,
};
